import {
  isNilOrZero,
} from '@populateui/utils';
import isNil from 'lodash/isNil';

const validChartTabs = [
  'demographics',
  'pcc',
  'visits',
  'vitals',
  'ledger',
  'insurance',
  'authorizations',
  'medications-and-allergies',
  'multimedia',
  'patient-history',
  'review-of-systems',
] as const;

export type ChartTab = typeof validChartTabs[number];

export const DEFAULT_CHART_TAB: ChartTab = 'demographics';

const validChartTabSet: ReadonlySet<string> = new Set(validChartTabs);

export function isValidChartTab(tab?: string | null): tab is ChartTab {
  return typeof tab === 'string' && validChartTabSet.has(tab);
}

export function getValidChartTab(tab?: string | null): ChartTab {
  return isValidChartTab(tab) ? tab : DEFAULT_CHART_TAB;
}

export function getPatientChartPath(
  patientId?: number | null,
  tab?: string | null,
): string | undefined {
  const tabPath = isNil(tab) ? '' : `/${getValidChartTab(tab)}`;

  return isNilOrZero(patientId)
    ? undefined
    : `/charts/${patientId}${tabPath}`;
}
